type ApiErrorResponse = {
	data?: unknown;
};

const DEFAULT_MSG =
	"Ops.. Tivemos um problema, por favor tente novamente mais tarde!";

export function extractApiErrorMessage(
	response?: ApiErrorResponse,
): string | undefined {
	const data = response?.data;

	if (!data || typeof data !== "object") return DEFAULT_MSG;

	const { content, detail, message, non_field_errors } = data as Record<
		string,
		unknown
	>;

	if (content && typeof content === "object") {
		const messages = Object.values(content)
			.flat()
			.filter((value): value is string => typeof value === "string");

		if (messages.length > 0) return messages.join(" ");
	}

	if (Array.isArray(non_field_errors)) {
		const messages = non_field_errors.filter(
			(value): value is string => typeof value === "string",
		);
		if (messages.length > 0) return messages.join(" ");
	}

	if (typeof detail === "string") return detail;
	if (typeof message === "string") return message;

	return DEFAULT_MSG;
}
